export interface MealPlanInput {
  gramsPerDay: number;
  mealsPerRecipe: Record<string, number>;
}

export interface MealPlanResult {
  gramsPerRecipe: Record<string, number>;
}

export function buildMealPlan(input: MealPlanInput): MealPlanResult {
  const { gramsPerDay, mealsPerRecipe } = input;
  const mealsPerDay = 2;

  const gramsPerMeal = gramsPerDay / mealsPerDay;

  const gramsPerRecipe: Record<string, number> = {};

  for (const recipeId of Object.keys(mealsPerRecipe)) {
    gramsPerRecipe[recipeId] = Math.round(
      gramsPerMeal * mealsPerRecipe[recipeId]
    );
  }

  return { gramsPerRecipe };
}
